import React from 'react';
import ChevronRight from '../assets/images/chevron-right.svg';

export default () => {
  return <img src={ChevronRight} alt="" />;
};
